import Vue from 'vue'
import VueRouter from 'vue-router'
import { configRouter } from './config_router.js'
import VueResource from 'vue-resource'
import App from './App.vue'

Vue.use(VueRouter)
Vue.use(VueResource)

const router = new VueRouter({
  // history: true,
  saveScrollPosition: true
})

configRouter(router)

// new Vue({
//   el: 'body',
//   components: { App }
// })

router.start(App, 'app');


// WEBPACK FOOTER //
// ./src/main.js